// based on http://dygraphs.com/mocks/base/interaction.js

import DyGraph from 'dygraphs';

const interactionModel = {
  ...DyGraph.defaultInteractionModel,
  wheel: ScrollV3,
};

export default interactionModel;

function ScrollV3(event, g) {
  let normal = event.detail ? event.detail * -1 : event.wheelDelta / 40;
  // For me the normalized value shows 0.075 for one click. If I took
  // that verbatim, it would be a 7.5%.
  let percentage = normal / 50;

  if (!(event.offsetX && event.offsetY)) {
    event.offsetX = event.layerX - event.target.offsetLeft;
    event.offsetY = event.layerY - event.target.offsetTop;
  }

  Zoom(g, percentage);
  event.preventDefault();
  event.stopPropagation();
}

function Zoom(g, ZoomInPercentage) {
  function adjustAxis(axis) {
    let delta = axis[1] - axis[0];
    let increment = delta * ZoomInPercentage;
    return [axis[0], axis[1] - increment];
  }
  let yAxes = g.yAxisRanges();
  let newYAxes = [];
  for (let i = 0; i < yAxes.length; i++) {
    newYAxes[i] = adjustAxis(yAxes[i], ZoomInPercentage);
  }
  g.updateOptions({
    valueRange: newYAxes[0],
  });
}
